<template>
	<transition v-if="showViewTypeMission" mode="out-in" name="fade">
		<router-view></router-view>
	</transition>
	<div v-else>
		<main class="main-wrapper flex-grow-1 with-footer">
			
			<div ref="learnHeader">
				<ViewHeader
						:basicData="basicData" :todayDate="todayDate"
				></ViewHeader>
			</div>
			<!-- subtabs -->
			<ViewSubTabWaiting v-if="!learStartStatus"
			                   :setTabFixed="setTabFixed"
			                   @setSubTab="setSubTab"
			></ViewSubTabWaiting>
			<ViewSubTab v-else
			            :tabType="tabType"
			            :setTabFixed="setTabFixed"
			            @setSubTab="setSubTab"
			></ViewSubTab>
			<div v-if="basicData && learStartStatus" class="">
				<component :is="tabType"
				           ref="contentsComp"
				           :basicData="basicData"
				           :teacher="basicData.teacher"
				           :todayDate="todayDate"
				           @setExamineeId="setExamineeId"
				           @setMissionId="setMissionId"
				           @setNextLesson="setNextLesson"
				           @setSurveyId="setSurveyId"
				></component>
			</div>
		</main>
		<transition v-if="screenTypeName !== 'LearnView'" mode="out-in" name="fade">
			<ViewFooter
					:basicData="basicData"
					:examineeId="examineeId"
					:missionId="missionId"
					:nextLessonData="nextLessonData"
					:setTabFixed="setTabFixed"
					:surveyId="surveyId"
					:tabType="tabType"
					:todayDate="todayDate"
			></ViewFooter>
		</transition>
	</div>
</template>

<script>
/**
 * 나의 학습 상세 메인 컴포넌트(my learning view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import learnApi from '@/api/learnApi.js'
import ViewHeader from './view/Header.vue'
import ViewFooter from './view/Footer.vue'
import ViewSubTab from './view/SubTab.vue'
import ViewSubTabWaiting from './view/SubTabWaiting.vue'
import ViewLesson from './view/Lesson.vue'
import ViewExam from './view/Exam.vue'
import ViewMission from './view/Mission.vue'
import ViewQuestion from './view/Question.vue'
import ViewSurvey from './view/Survey.vue'

export default {
	data() {
		return {
			tabType: 'ViewLesson',
			basicData: null,
			setTabFixed: false,
			nextLessonData: null,
			
			learStartStatus: false,
			examineeId: 0,
			missionId: 0,
			surveyId: 0,
			showViewTypeMission: false,
			screenTypeName: null,
			todayDate: this.$moment(new Date()).valueOf(),
		}
	},
	
	components: {
		ViewHeader, ViewFooter, ViewSubTab, ViewSubTabWaiting, ViewLesson, ViewExam, ViewMission, ViewQuestion, ViewSurvey
	},
	
	mounted() {
		//alert(this.$route.query.tab)
		this.statusTab = this.$route.query.status;
		this.tabType = this.$route.query.tab || 'ViewLesson';
	},
	
	mixins: [topAppBarMixin],
	
	beforeMount() {
		const showListRouterChild =
				[
					'LessonQuestion',
					'LearnViewQuestion',
					'LearnViewMissionUpdate',
					'FinalExamFeedback',
					'LearnViewMission',
					'FinalExamResult',
					'FinalExamTake',
					'FinalExamIntro',
					'LessonExamFeedback',
					'LessonExamResult',
					'LessonExamTake',
					'LessonExamIntro',
					'LearnViewMissionSubmit',
					'LearnViewMissionViewSubmit',
					'IndependentExamResultFeedbackIssue',
					'LessonExamFeedbackIssue',
					'FinalExamFeedbackIssue',
					'FinalExamFeedbackQuestion',
					'LessonExamFeedbackQuestion',
					'IndependentExamResultFeedbackQuestion'
				];
		if (showListRouterChild.includes(this.$router.currentRoute.name)) {
			this.showViewTypeMission = true;
		}
		this.fetchData()
	},
	watch: {
		$route() {
			this.statusTab = this.$route.query.status;
			let getExamResult = this.$route.query.examresult;
			if (getExamResult === 'getscore') {
				this.fetchData()
			}
		},
	},
	updated() {
		this.screenTypeName = this.$route.name;
	},
	methods: {
		// 텝 설정(set tab)
		setSubTab(type) {
			this.tabType = type;
			
		},
		
		// 기본정보 API 호출 및 데이터 설정(get data)
		fetchData() {
			let responseData = null
			let params = this.setParams()
			//this.$showLoading()
			
			// get learn basic information
			learnApi.learnViewBasic(params).then((response) => {
				this.basicData = response.data.data
				
				// set learning status
				learnApi.learnStart(params).then((response) => {
					this.learStartStatus = true
				})
				
				//this.$hideLoading()
			}).catch((err) => {
				responseData = err.response.data.meta
				this.$error({content: responseData.errMsg}).then(() => {
				})
			})
			
		},
		
		//파라미터 설정(set parameter)
		setParams() {
			const params = {
				learnId: this.$route.params.learnId
			}
			return params
		},
		
		// 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
		scrollMove(el) {
			if (parseInt(el.scrollTop) >= parseInt(this.$refs.learnHeader.offsetHeight)) {
				this.setTabFixed = true
			} else {
				this.setTabFixed = false
			}
		},
		
		// set next lesson
		setNextLesson(data) {
			this.nextLessonData = data
		},
		
		// set examinee
		setExamineeId(data) {
			this.examineeId = data
		},
		
		// set mission
		setMissionId(data) {
			this.missionId = data
		},
		
		// set survey
		setSurveyId(data) {
			this.surveyId = data
		}
	}
}
</script>
